/**
 * Created by karora on 29/05/17.
 * @class
 * @description
 * Wrapper for HTML5 audio.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class AudioAPIWrapper{

  private audioElement: HTMLMediaElement;

  constructor() {
    this.createAudio();
  }
  createAudio() {
    if(!this.audioElement){
      this.audioElement = new Audio();
      this.audioElement.autoplay = false;
      this.audioElement.preload = 'auto';
      try {
        (<any>this.audioElement).autobuffer = true;
      } catch(e) {
        console.log(e.message);
      }
    }
  }

  public Play(){
    try {
      let promise: any = this.audioElement.play();
      if (!!promise) {
        promise.catch(() => {this.audioElement.play();});
      }
    } catch(e) {
      console.log(e.message);
    }
  }

  public Pause(){
    this.audioElement.pause();
  }

  public Stop(){
    this.audioElement.pause();
  }

  public GetDuration(): number {
    return this.audioElement.duration;
  }

  public CurrentTime(setPosition: number | null): number {
    if (setPosition) {
      this.audioElement.currentTime = setPosition;
    }
    return this.audioElement.currentTime
  }

  public Load(url: string): number{
    this.createAudio();
    this.audioElement.src = url;
    this.audioElement.load();
    this.Pause();
    return this.audioElement.duration;
  }

}
